import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Assessment, SpeakerPhone } from "@material-ui/icons";
import Equalizer from "@material-ui/icons/Equalizer";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

export default function StockModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.SUPER_USER]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/stock");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<Equalizer />}
      header={t("stock.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/stock/modify");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <SpeakerPhone />
        </ListItemIcon>
        <ListItemText primary={t("stockModule.modifyStock")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/stock/statistics");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <Assessment />
        </ListItemIcon>
        <ListItemText primary={t("stockModule.stockStatistics")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
